import { ImageLoaderCSSStyleImpl } from '../../../toolkit/imageloader/imageloadercss';

export class TuneSettingImageLoaderCSSStyleImpl extends ImageLoaderCSSStyleImpl
{
    getImgCSSStyle(): object 
    {
        return {
            objectFit: 'cover', 
            // width: '131px', 
            // height: '140px',
            width:'262px', 
            height:'280px',
            borderRadius: "15px 0px 15px 0px",
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/tunesettings/tunesettingimageloader.tsx